var map = {
	"./animalqtldb.png": 9774,
	"./bgee.png": 7858,
	"./biogrid.png": 4908,
	"./clinvar.png": 5147,
	"./coriell.png": 3830,
	"./ctd.png": 9912,
	"./decipher.png": 22,
	"./ebigene2phen.png": 1031,
	"./ensembl.png": 3407,
	"./eom.png": 219,
	"./flybase.png": 9902,
	"./geneontology.png": 6784,
	"./genereviews.png": 6120,
	"./gwascatalog.png": 455,
	"./hgnc.png": 8238,
	"./hpo.png": 9277,
	"./impc.png": 8877,
	"./kegg.png": 1856,
	"./mgi.png": 5231,
	"./mmrrc.png": 5161,
	"./monarch.png": 6129,
	"./monochrom.png": 8030,
	"./mpd.png": 4435,
	"./mychem.png": 7979,
	"./mydrug.png": 3519,
	"./mygene.png": 580,
	"./ncbi.png": 8192,
	"./omia.png": 1358,
	"./omim.png": 9000,
	"./orphanet.png": 5882,
	"./panther.png": 5303,
	"./pharmgkb.png": 5246,
	"./reactome.png": 9448,
	"./rgd.png": 4596,
	"./sgd.png": 6550,
	"./string.png": 4149,
	"./ucscbands.png": 4924,
	"./udp.png": 434,
	"./vega.png": 6187,
	"./wormbase.png": 5193,
	"./zfin.png": 7548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3937;